// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__vwH2p","balanceDisclaimer":"posDashboard_balanceDisclaimer__11MEf"};